import {BackendPointDetail} from 'components/Backend/PointCard/Detail';

export default BackendPointDetail;
